import React from 'react';

import { H3, Text } from 'components/core/Typography';
import { Container } from 'components/core/Page';
import { Card } from 'components/legacy/Card';
import { Image } from 'components/core/Image';
import depot from 'assets/images/plp/depot.svg';
import dollar from 'assets/images/plp/dollar.svg';
import nocredit from 'assets/images/plp/no-credit.svg';
import placemarker from 'assets/images/plp/place-marker.svg';

import './WhySSDC.scss';

const features = [
	{
		img: placemarker,
		text: 'Use our map to discover nearby storage in seconds.',
	},
	{
		img: depot,
		text: 'Simply search features to find your perfect match.',
	},
	{
		img: dollar,
		text: 'Find the best rate for your needs and budget.',
	},
	{
		img: nocredit,
		text: 'Reserve now, pay later.',
	},
];

export function WhySSDC() {
	return (
		<section
			className="why-ssdc"
			id="why-ssdc"
		>
			<Container>
				<H3
					color="white"
					size="large"
					centered
				>
					Why SelfStorage.com
				</H3>
				<div className="why-ssdc-content">
					{features.map((feature) => (
						<Card
							className="why-ssdc-card"
							key={feature.text}
						>
							<Image
								src={feature.img}
								className="card-icon"
								alt={feature.text}
							/>
							<Text>{feature.text}</Text>
						</Card>
					))}
				</div>
			</Container>
		</section>
	);
}
